import React from "react";
import {
  Row,
  Col,
  Input,
  Select,
} from '@lockerpm/design';

import {
  SearchOutlined
} from "@ant-design/icons";

import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import global from "../../../../../config/global";

const Filter = (props) => {
  const { t } = useTranslation()
  const {
    className = '',
    params = {},
    setParams = () => { }
  } = props;


  return (
    <Row
      className={`filter ${className}`}
      justify={'space-between'}
      gutter={[0, 8]}
    >
      <Col lg={24} md={24} className="w-full">
        <Row
          justify={'left'}
          gutter={[12, 12]}
        >
          <Col xl={4} lg={6} md={8} xs={12}>
            <p className="font-semibold mb-1">{t('common.email')}</p>
            <Input
              prefix={<SearchOutlined />}
              value={params.email}
              placeholder={t('placeholder.email')}
              onChange={(e) => setParams({ ...params, page: 1, email: e.target.value })}
            />
          </Col>
          <Col xl={4} lg={6} md={8} xs={12}>
            <p className="font-semibold mb-1">{t('common.status')}</p>
            <Select
              className="w-full"
              placeholder={t('placeholder.select')}
              value={params.status}
              onChange={(v) => setParams({ ...params, page: 1, status: v })}
            >
              <Select.Option
                value={''}
                key={'all'}
              >
                {t('common.all')}
              </Select.Option>
              {global.constants.WORKSPACE_MEMBER_STATUSES.map((status) => (
                <Select.Option
                  value={status.value}
                  key={status.value}
                >
                  {t(status.label)}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Filter;
